









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import inputFormatConfig, { FormatInputType } from './format-type';

@Component
export default class FormatInput extends Vue {
  @Prop({ default: '' }) public value!: string;
  @Prop({ default: '' }) public placeholder!: string;
  @Prop({ default: 'text' }) public type!: string;
  @Prop({ default: true }) public enableClear!: boolean;
  @Prop({ default: 19 }) public maxlength!: number;
  @Prop({ default: FormatInputType.defalut }) public formatType!: FormatInputType;

  /** 输入的value */
  public inputValue = '';

  @Watch('inputValue')
  onInputValueChanged() {
    const value = this.formatOutput(this.inputValue);
    this.$emit('input', value);
  }

  /** 获取输入框输入类型 */
  public get inputType() {
    const { type, formatType, currFormatConfig } = this;
    if (formatType !== FormatInputType.defalut) {
      return currFormatConfig.type;
    }
    return type;
  }

  public get currFormatConfig() {
    return inputFormatConfig[this.formatType];
  }

  public get isShowClearBtn() {
    const { enableClear, inputValue } = this;
    return enableClear && !!inputValue;
  }

  public handleInput() {
    this.inputValue = this.formatInput(this.inputValue);
  }

  public handleClear() {
    this.inputValue = '';
  }

  /**
   * 格式化输入的内容，比如说输入银卡时转换为4位一展示： 123456789012345 => 1234 5678 9012 3456
   * @param value 当前input框输入的内容
   */
  public formatInput(value: string) {
    const { currFormatConfig } = this;
    const { format } = currFormatConfig;
    return format?.input ? format.input(value) : value;
  };

  /**
   * 输出时对内容格式化，如：银行卡输入完毕后，需要去除中间的空格：1234 5678 9012 3456 => 123456789012345
   * @param value 当前input框输入的内容
   */
  public formatOutput(value: string) {
    const { currFormatConfig } = this;
    const { format } = currFormatConfig;
    return format?.output ? format.output(value) : value;
  }
}
